module.exports = __webpack_public_path__ + "img/tszy.ff139461.png";